// import produce from 'immer'
// import React, { useEffect, useState } from 'react'
// import { useSelector, useDispatch } from 'react-redux'
// import { useRouteMatch, useHistory } from 'react-router-dom'
// import FileAllocationFilters from '../../../../components/filters/FileAllocationFilters'
// import IterminalTableComponent from '../../../../components/table/IterminalTableComponent'
// import { FilterModel } from '../../../../models/utils/filterModel'
// import { FilterOptionModel } from '../../../../models/utils/filterOption'
// import { filtersSetRequest } from '../../../../store/filter/actions'
// import { getFilters } from '../../../../store/filter/selectors'
// import {
//   fileAllocationFilters,
//   fileRegistrationColumns,
// } from '../../../../utils/metaData'
// import { getPageCount } from '../../../../utils/tableFunctions'
// import rlpDataService from '../../../../services/applicationRegistration/compensation/rlpService'
// import {
//   defaultOrderListLimit,
//   defaultPageLimit,
// } from '../../../../utils/constants'

// const RlpApplication = () => {
//   const filterOption = {
//     descending: true,
//     limit: defaultPageLimit,
//     orderFields: defaultOrderListLimit,
//   } as FilterModel
//   const [filter, setFilter] = useState(filterOption)
//   const [pageCount, setPageCount] = useState(0)
//   const [dataCount, setDatacount] = useState(0)
//   const [state, setstate] = useState([])
//   const [loading, setLoading] = useState(true)
//   const filters = useSelector(getFilters)
//   const { path } = useRouteMatch()
//   const history = useHistory()
//   const dispatch = useDispatch()

//   useEffect(() => {
//     dispatch(filtersSetRequest({ filters: fileAllocationFilters }))
//     async function getApplicationFiles() {
//       await retriveDataCountAndData(filter)
//       setLoading(false)
//     }
//     getApplicationFiles()
//   }, [])
//   const columns = React.useMemo(() => fileRegistrationColumns, [])

//   const retriveApplicationFilesData = async (pageDetails: any) => {
//     setLoading(true)
//     const newFilter = produce(filter, (draft) => {
//       draft.page = pageDetails.pageIndex + 1
//     })
//     setFilter(newFilter)
//     const applicationData = await rlpDataService.apiFetchRlpList(newFilter)
//     setstate(applicationData.data)
//     setLoading(false)
//   }

//   const retriveFilterData = async (selectedFilters: FilterOptionModel[]) => {
//     console.log(selectedFilters)
//     setLoading(true)
//     const newFilter = produce(filter, (draft) => {
//       draft.page = 1
//       draft.filterData = selectedFilters
//     })
//     setFilter(newFilter)
//     await retriveDataCountAndData(newFilter)
//     setLoading(false)
//   }

//   async function retriveDataCountAndData(filterData: FilterModel) {
//     const applicationCountData = await rlpDataService.apiFetchRlpListCount(
//       filterData
//     )
//     if (applicationCountData.status === 200) {
//       setDatacount(applicationCountData.data.count)
//       setPageCount(
//         getPageCount(applicationCountData.data.count, filterOption.limit)
//       )
//       const applicationData = await rlpDataService.apiFetchRlpList(filterData)
//       setstate(applicationData.data)
//     } else {
//       setDatacount(0)
//       setPageCount(0)
//       setstate([])
//     }
//   }

//   const handleView = (id: number) => {
//     history.push(`${path}view/${id}`)
//   }

//   return (
//     <>
//       {!loading && (
//         <div className="mb-4">
//           <FileAllocationFilters
//             filterData={filters}
//             onFilter={(e: FilterOptionModel[]) => {
//               dispatch(filtersSetRequest({ filters: e }))
//               retriveFilterData(
//                 e.filter(
//                   (filter: FilterOptionModel) => filter.selected === true
//                 )
//               )
//             }}
//           />
//         </div>
//       )}
//       <div>
//         <IterminalTableComponent
//           columns={columns}
//           data={state}
//           fetchData={retriveApplicationFilesData}
//           loading={loading}
//           pageCount={pageCount}
//           totalCount={dataCount}
//           onClickRow={(row: any) => {
//             handleView(row.id)
//           }}
//         />
//       </div>
//     </>
//   )
// }

// export default RlpApplication

import { useEffect } from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'
import { defaultPageLimit } from '../../../../utils/constants'
import AdvancedSearchTable from '../../../../components/table/advancedSearchTable/AdvancedSearchTable'
import { applicationCommonColumns } from '../../../../components/table/advancedSearchTable/AdvancedSearchTableUtil'
import { AdvancedFilterModel } from '../../../../models/utils/filterModel'
import { useDispatch } from 'react-redux'
import { filtersSetRequest } from '../../../../store/filter/actions'
import { fileAllocationFilters } from '../../../../utils/metaData'

const RlpApplication = () => {
  // Initialize the filter option as per the AdvancedSearchTable requirements
  const initFilterOption = {
    filterValue: null,
    limit: defaultPageLimit, // Adjust if needed
    page: 1,
    orderBy: 'created_date_time', // Adjust the default orderBy field if necessary
    order: 'DESC',
  } as AdvancedFilterModel

  const { path } = useRouteMatch()
  const history = useHistory()
  const dispatch = useDispatch()

  // Effect to set the filters in the Redux store
  useEffect(() => {
    dispatch(filtersSetRequest({ filters: fileAllocationFilters }))
  }, [dispatch])

  // Handle row click event
  const handleView = (id: number) => {
    history.push(`${path}view/${id}`)
  }

  return (
    <>
      <AdvancedSearchTable
        initFilterOption={initFilterOption} // Pass the initialized filter option
        columns={applicationCommonColumns} // Use the columns relevant to your data
        dataApiPath={'/application-registration/compensation/rlp/view/list'} // Set to your actual data API path
        countApiPath={'/application-registration/compensation/rlp/view/count'} // Set to your actual count API path
        onClickRow={(row: any) => {
          handleView(row.id) // Handle row clicks
        }}
      />
    </>
  )
}

export default RlpApplication
